export default "__VITE_ASSET__CJtu8lCZ__"